module.exports = __webpack_public_path__ + "static/img/banner2.c4b21d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner2.png
// module id = 6XiN
// module chunks = 1